import { render, staticRenderFns } from "./BoxService.vue?vue&type=template&id=2255d8a3&scoped=true&"
import script from "./BoxService.vue?vue&type=script&lang=js&"
export * from "./BoxService.vue?vue&type=script&lang=js&"
import style0 from "./BoxService.vue?vue&type=style&index=0&id=2255d8a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255d8a3",
  null
  
)

export default component.exports